module.exports = "data:image/webp;base64,UklGRrgAAABXRUJQVlA4IKwAAADwBACdASoZABkAPoE2lEelIyIhN/qoAKAQCWcAx+trME0lULtDfiG5MdHAUFA2T8AA/vFxI90m2JrqNR+AfmYhaQnYgcPgXZcGNBEoBnpkU7mYduUBibZO9LNUInpWTTjX6e5zIH1UsviUpD13pAAO5gToHL7fVvV5qnMJIFIDeYIO/m9VfRwwi2bHCR1tv1C/it18nyE5f2X3nqfmlrPhruGeVENn3jUvNAAA"


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/chocolate.webp
// module id = SpOE
// module chunks = 14